// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3gSfK","col":"styles_col__225Rr"};